import axios from "axios";
import React, { useEffect, useState } from "react";
import NKJFlowReceived from "./NKJFlowReceived";
import NKJFlowChart from "./NKJFlowChart";
import NKJFlowMonthWise from "./NKJFlowMonthWise";
import NoDataFound from "../../../../Extra/NoDataFound";

const NKJFlowMaster = ({ selectedFy, selectedFilters }) => {
  const selectedMonth = [...selectedFilters.selectedMonth];
  const selectedYear = [...selectedFilters.selectedYear];

  const [rawData, setRawData] = useState([]);
  const [rawDisData, setRawDisData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const fd = [];
  const fd2 = [];
  const fd3 = [];
  const fd4 = [];

  for (let i = 0; i < selectedYear.length; i++) {
    const y = selectedYear[i];
    fd3.push(...rawData.filter((o) => o.f_year === y));
    fd4.push(...rawDisData.filter((o) => o.f_year === y));
  }

  for (let i = 0; i < selectedMonth.length; i++) {
    const m = selectedMonth[i]?.slice(0, 3).toLowerCase();
    fd.push(...fd3.filter((o) => o.a_month?.toLowerCase() === m));
    fd2.push(...fd4.filter((o) => o.a_month?.toLowerCase() === m));
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}getNKJTrafficFlowReceivedData?FyYear=${selectedFy}`,
        );
        if (response.status === "ok" && Array.isArray(response.data)) {
          setRawData(response.data);
        }
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}getNKJTrafficFlowDispatchedData?FyYear=${selectedFy}`,
        );
        if (response.status === "ok" && Array.isArray(response.data)) {
          setRawDisData(response.data);
        }
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-md-6 mb-3">
          <div className="newUiBodyNM mb-3">
            <h6 className="p-3 bg-dark text-white ">RECEIVED FY SUMMARY</h6>
            {fd.length ? <NKJFlowReceived data={fd} /> : <NoDataFound />}
          </div>

          <div className="newUiBodyNM">
            <h6 className="p-3 bg-dark text-white ">DISPATCHED FY SUMMARY</h6>
            {fd2.length ? <NKJFlowReceived data={fd2} /> : <NoDataFound />}
          </div>
        </div>

        <div className="col-12 col-md-6 mb-3">
          <div className="newUiBodyNM mb-3">
            <h6 className="p-3 bg-dark text-white ">RECEIVED CHART</h6>
            {fd.length ? <NKJFlowChart data={fd} /> : <NoDataFound />}
          </div>

          <div className="newUiBodyNM">
            <h6 className="p-3 bg-dark text-white ">DISPATCHED CHART</h6>
            {fd2.length ? <NKJFlowChart data={fd2} /> : <NoDataFound />}
          </div>
        </div>
      </div>

      <div className="row ">
        <div className="col-12 mb-3">
          <div className="newUiBodyNM">
            <h6 className="p-3 bg-dark text-white ">
              NKJ YARD FLOW RECEIVED MONTH WISE SUMMARY
            </h6>
            {fd.length ? (
              <NKJFlowMonthWise data={fd} selectedFy={selectedFy} />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>

        <div className="col-12 mb-3">
          <div className="newUiBodyNM">
            <h6 className="p-3 bg-dark text-white">
              NKJ YARD FLOW DISPATCHED MONTH WISE SUMMARY
            </h6>
            {fd2.length ? (
              <NKJFlowMonthWise data={fd2} selectedFy={selectedFy} />
            ) : (
              <NoDataFound />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NKJFlowMaster;
